import React from 'react';

import { Check as CheckIcon } from '@styled-icons/boxicons-regular/Check';
import { TrashAlt as TrashAltIcon } from '@styled-icons/boxicons-solid/TrashAlt';
// import { Warning as WarningIcon } from '@styled-icons/entypo/Warning';
import { Close as CloseIcon } from '@styled-icons/evaicons-solid/Close';
import AlphaIBoxOutlineIcon from 'mdi-react/AlphaIBoxOutlineIcon';
import MdiGroupIcon from 'mdi-react/GroupIcon';

import {
  Box,
  Icon,
  Tr,
  Td,
  Text,
  Flex,
  // Tooltip,
  HStack,
  Button,
  IconButton,
} from '@chakra-ui/react';

import { Row, FlattenedComponent } from './types';

export type Composition = {
  price: number;
  unit_price_was_changed: boolean;
  unit_price_original: number;
  newQuantity: number;
  recursive_quantity: number;
  outdated_price: boolean;
  composition_price: {
    custom_description: string | null;
    base: {
      description: string;
    };
    version: {
      description: string;
    };
    composition: {
      code: string;
      description: string;
      kind: 'informed' | 'common';
      version: {
        year?: number;
        month?: number;
        description: string;
        base: {
          description: string;
        };
      };
      unit_measure: {
        description: string;
      };
    };
  };
};

interface RowProps {
  row: Row & { original: FlattenedComponent & Composition };
  activeTab: 'list' | 'selected';
  isSiengeBudget: boolean;
  selectedComponents: FlattenedComponent[];
  handleSelectComponent: (component: FlattenedComponent) => void;
  handleDeleteComponent: (component: FlattenedComponent) => void;
}

const CompositionRow: React.FC<RowProps> = ({
  row,
  activeTab,
  // isSiengeBudget,
  selectedComponents,
  handleSelectComponent,
  handleDeleteComponent,
}) => {
  return (
    <Tr {...row.getRowProps()}>
      <Td>
        <Box
          display="flex"
          flexDir="column"
          ml="1"
          justifyContent="center"
          alignItems="center"
          title="Serviço"
          fontWeight="bold"
        >
          {row.original.location}
          {row.original.composition_price.composition.kind === 'informed' ? (
            <Icon w={5} h={5} as={AlphaIBoxOutlineIcon} />
          ) : (
            <Icon w={5} h={5} as={MdiGroupIcon} />
          )}
        </Box>
      </Td>

      <Td title="Base / Referência">
        <Text textAlign="center">
          {row.original.composition_price.base?.description}
        </Text>

        <Text
          textAlign="center"
          whiteSpace="pre-wrap"
          maxWidth={{ base: '100%', md: '650px' }}
        >
          {row.original.composition_price.version?.description}
        </Text>
      </Td>

      <Td>{row.original.composition_price.composition.code}</Td>

      <Td>
        <Text
          py={1}
          whiteSpace="pre-wrap"
          maxWidth={{ base: '100%', md: '650px' }}
        >
          {row.original.composition_price.custom_description ||
            row.original.composition_price.composition.description}
        </Text>
      </Td>

      <Td isNumeric>
        {Intl.NumberFormat('pt-BR', {
          maximumFractionDigits: 4,
        }).format(row.original.quantity)}
      </Td>

      <Td isNumeric>
        <Flex gap={2} alignItems="center" justifyContent="flex-end">
          <Text>
            {Intl.NumberFormat('pt-BR', {
              style: 'currency',
              currency: 'BRL',
            }).format(row.original.social_law_price)}
          </Text>

          {/* {row.original.outdated_price && !isSiengeBudget && (
            <Tooltip
              ml={1}
              hasArrow
              label="Serviço com preço desatualizado em relação a sua versão original."
            >
              <Icon as={WarningIcon} className="icon" />
            </Tooltip>
          )} */}
        </Flex>
      </Td>

      <Td isNumeric>
        {Intl.NumberFormat('pt-BR', {
          style: 'currency',
          currency: 'BRL',
        }).format(row.original.price)}
      </Td>

      <Td isNumeric>
        {Intl.NumberFormat('pt-BR', {
          style: 'currency',
          currency: 'BRL',
        }).format(row.original.total)}
      </Td>

      <Td>
        {activeTab === 'list' ? (
          <HStack spacing={2}>
            <Button
              colorScheme="green"
              leftIcon={<Icon as={CheckIcon} />}
              onClick={() => handleSelectComponent(row.original)}
              disabled={selectedComponents.some(
                (c) => c.id === row.original.id,
              )}
            >
              {selectedComponents.some((c) => c.id === row.original.id)
                ? 'Selecionado'
                : 'Selecionar'}
            </Button>

            {selectedComponents.some((c) => c.id === row.original.id) && (
              <IconButton
                aria-label="Remover serviço"
                colorScheme="red"
                icon={<Icon as={CloseIcon} />}
                onClick={() => handleDeleteComponent(row.original)}
              />
            )}
          </HStack>
        ) : (
          <Button
            tabIndex={-1}
            colorScheme="red"
            leftIcon={<Icon as={TrashAltIcon} />}
            onClick={() => handleDeleteComponent(row.original)}
          >
            Remover
          </Button>
        )}
      </Td>
    </Tr>
  );
};

export default CompositionRow;
